/* eslint-disable prettier/prettier */
import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { GetChargebackDetails } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const fetchChargebackDetails = createAsyncThunk('get/chargebackDetails', GetChargebackDetails);

export const FetchChargebackDetailsSlice = createSlice({
	name: 'fetchChargebackDetails',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[fetchChargebackDetails.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[fetchChargebackDetails.rejected.toString()]: setAPIError,
		[fetchChargebackDetails.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = payload;
		},
	},
});

interface IStates {
	[FetchChargebackDetailsSlice.name]: ReturnType<typeof FetchChargebackDetailsSlice.reducer>;
}

export const fetchChargebackDetailsSelector = (state: IStates): any => {
	return state[FetchChargebackDetailsSlice.name] || {};
};

export const useChargebackDetails = (): any => useSelector(fetchChargebackDetailsSelector);

export const getChargebackDetails =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(fetchChargebackDetails(params));
		return;
	};

export const resetChargebackDetails =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(FetchChargebackDetailsSlice.actions.RESET());
		return;
	};
